<template>
  <div class="contact-item" :class="activeClass" v-show="open" @click="activeChange">
    <span style="width: 14px"></span>
    <account-avatar :account="contact" />
    <div class="contact-item-name">{{ contact.im_name }}</div>
  </div>
</template>

<script>
import AccountAvatar from '../../AccountAvatar.vue'
export default {
  name: 'ContactItem',
  components: {
    AccountAvatar
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    contact: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    activeClass () {
      return this.isActive ? 'active' : ''
    }
  },
  watch: {
  },
  methods: {
    activeChange () {
      this.$emit('active-change', this.contact)
    }
  }
}
</script>

<style lang="stylus" scoped>
.contact-item {
  display: flex;
  font-size: 14px;
  color: #333;
  padding: 12px;
  position: relative;
  cursor: pointer;
  transition: all .3s cubic-bezier(.645,.045,.355,1);
  align-items: center;
  gap: 5px;
}
.contact-item-name {
  margin: 0 6px 0 5px;
}
.active {
  background-color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/common/im/right/contacts/ContactItem.vue